import React, { useEffect, useRef } from "react";
import { Pencil, X } from "lucide-react";
import ChallengeCalculator from "../weeklyChallenges/challengeCalculator";
import LoserOfTheWeek from "../LoserOfTheWeek";

interface EditLoserOfTheWeekModalProps {
  loserId?: string;
  isAdmin: boolean;
  onSaveSuccess?: () => void;
  buttonClassName?: string;
  setIsEdit?: (value: boolean) => void;
  isEdit?: boolean;
  onClose?: () => void;
}

const EditLoserOfTheWeekModal: React.FC<EditLoserOfTheWeekModalProps> = ({
  loserId,
  isAdmin,
  onSaveSuccess,
  buttonClassName = "bg-[#18f7b1] hover:bg-[#0fd494] text-black px-4 py-2 rounded-lg flex items-center gap-2 float-right",
  setIsEdit,
  isEdit,
  onClose,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isAdmin) {
    return null;
  }

  const handleSaveSuccess = () => {
    setIsOpen(false);
    if (onSaveSuccess) {
      onSaveSuccess();
    }
  };

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(true);
          setIsEdit?.(false);
        }}
        className="btnPrimary iconBtn"
      >
        <Pencil size={20} />
      </button>

      {isOpen && (
        <div className="popupWrapper">
          <div ref={modalRef} className="popupContBlkBig">
            <div className="popupHeadingBlk">
              <h4>Edit Loser Of The Week</h4>
              <div>Make changes to the LOTW content below.</div>
              <button
                onClick={() => (onClose ? onClose() : setIsOpen(false))}
                className="closePopup"
              >
                <X size={20} />
              </button>
            </div>

            <div className="p-4">
              <LoserOfTheWeek
                loserId={loserId}
                onSaveSuccess={handleSaveSuccess}
                setIsEdit={setIsEdit}
                isEdit={isEdit}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditLoserOfTheWeekModal;
